
export const listOfPaymentMethodsIdsThatCannotRemove = [
    'tdc_mercado_pago'
];